import { getMarket } from '../i18n';
import { phonenumbers } from './index';
import {
  UUIDReg,
  UrlReg,
  emailReg,
  regexRegnrNo,
  regexRegnrSe,
  regexZipNo,
  regexZipSe,
} from './regExp';

const fieldValidation = {
  optionalString: (s?: string | null) => !s || !!s,
  requiredString: (s?: string | null) => !!s,
  optionalBool: (s?: boolean | null) => !s || !!s,
  optionalNumber: (s?: string | number | null) =>
    s === null || s === undefined || !Number.isNaN(+s),
  requiredNumber: (s?: string | number | null) =>
    s !== null && s !== undefined && !Number.isNaN(+s),
  optionalEmail: (s?: string | null) => !s || emailReg.test(s),
  requiredEmail: (s?: string | null) => emailReg.test(s || ''),
  optionalUrl: (s?: string | null) => !s || UrlReg.test(s),
  requiredUrl: (s?: string | null) => UrlReg.test(s || ''),
  optionalUUID: (s?: string) => !s || UUIDReg.test(s),
  requiredUUID: (s?: string) => UUIDReg.test(s || ''),
  optionalStringArray: (s?: string[]) => !s || !!s?.find((x) => !x),
  optionalNumberGreaterOrEqualThanZero: (s?: string | number | null) => {
    if (s === undefined || s === null) {
      return true;
    }
    const f = Number.parseInt(s.toString(), 10);
    return !Number.isNaN(f) && f >= 0;
  },
  requiredRegNr: (s?: string | null, marketcode?: string) => {
    if (marketcode === 'NO') {
      return regexRegnrNo.test(s || '');
    }
    return regexRegnrSe.test(s || '');
  },
  requiredZip: (s?: string | null, marketcode?: string) => {
    if (marketcode === 'NO') {
      return regexZipNo.test(s || '');
    }
    return regexZipSe.test(s || '');
  },
  requiredPhoneNumber: (s?: string | null) => {
    const { marketCode } = getMarket();
    const phoneNumber = phonenumbers.parse(s || '', marketCode);
    return phoneNumber?.isValid() || false;
  },

  optionalPhonenumber: (s: string | null | undefined | number) => {
    const { marketCode } = getMarket();
    if (!s) return true;

    const phoneNumber = phonenumbers.parse(s?.toString() || '', marketCode);
    return phoneNumber?.isValid() || false;
  },
};

export default fieldValidation;
